import { defineEnum } from '@siclop/kstone-vue'

export enum LeaveCategory {
  PaidLeave = 0,
  RTT = 1,
  SickLeave = 2,
  Unpaid = 3,
  Parental = 4,
  Training = 5,
  FamilyEvent = 6,
  WorkAccident = 7,
  Other = 99
}

export const useLeaveCategoryLabels = defineEnum({
  i18nPrefix: 'ksproject.enums.leaveCategory',
  entries: {
    [LeaveCategory.PaidLeave]: { key: 'paidLeave', label: 'Congés payés', color: '#67C23A' },
    [LeaveCategory.RTT]: { key: 'rtt', label: 'RTT', color: '#409EFF' },
    [LeaveCategory.SickLeave]: { key: 'sickLeave', label: 'Arrêt maladie', color: '#F56C6C' },
    [LeaveCategory.Unpaid]: { key: 'unpaid', label: 'Sans solde', color: '#909399' },
    [LeaveCategory.Parental]: { key: 'parental', label: 'Congé parental', color: '#E6A23C' },
    [LeaveCategory.Training]: { key: 'training', label: 'Formation', color: '#9B59B6' },
    [LeaveCategory.FamilyEvent]: { key: 'familyEvent', label: 'Événement familial', color: '#1ABC9C' },
    [LeaveCategory.WorkAccident]: { key: 'workAccident', label: 'Accident du travail / maladie pro', color: '#C0392B' },
    [LeaveCategory.Other]: { key: 'other', label: 'Autre', color: '#606266' }
  }
})

/** @deprecated Utiliser useLeaveCategoryLabels().getLabel() */
export const LeaveCategoryLabels: Record<LeaveCategory, string> = {
  [LeaveCategory.PaidLeave]: 'Congés payés',
  [LeaveCategory.RTT]: 'RTT',
  [LeaveCategory.SickLeave]: 'Arrêt maladie',
  [LeaveCategory.Unpaid]: 'Sans solde',
  [LeaveCategory.Parental]: 'Congé parental',
  [LeaveCategory.Training]: 'Formation',
  [LeaveCategory.FamilyEvent]: 'Événement familial',
  [LeaveCategory.WorkAccident]: 'Accident du travail / maladie pro',
  [LeaveCategory.Other]: 'Autre'
}

/** @deprecated Utiliser useLeaveCategoryLabels().getColor() */
export const LeaveCategoryColors: Record<LeaveCategory, string> = {
  [LeaveCategory.PaidLeave]: '#67C23A',
  [LeaveCategory.RTT]: '#409EFF',
  [LeaveCategory.SickLeave]: '#F56C6C',
  [LeaveCategory.Unpaid]: '#909399',
  [LeaveCategory.Parental]: '#E6A23C',
  [LeaveCategory.Training]: '#9B59B6',
  [LeaveCategory.FamilyEvent]: '#1ABC9C',
  [LeaveCategory.WorkAccident]: '#C0392B',
  [LeaveCategory.Other]: '#606266'
}

/** @deprecated Utiliser useLeaveCategoryLabels().options */
export function getLeaveCategoryOptions() {
  return Object.values(LeaveCategory)
    .filter(v => typeof v === 'number')
    .map(value => ({
      value: value as LeaveCategory,
      label: LeaveCategoryLabels[value as LeaveCategory],
      color: LeaveCategoryColors[value as LeaveCategory]
    }))
}
